<app-header></app-header>
<app-sidenav>
    <app-masquerade-header></app-masquerade-header>
    <div
        id="content"
        class="relative"
        [class.h-full]="!isMasqueraded()"
        [class.h-full-adjusted-for-masquerade-header]="isMasqueraded()"
        [class.pointer-events-none]="loading$ | async"
    >
        <router-outlet></router-outlet>
        @if (loading$ | async) {
            <app-loading></app-loading>
        }
    </div>
</app-sidenav>
<app-footer></app-footer>
